import { call, put, takeEvery } from "redux-saga/effects";
import {
  getHazardReportByLocationFail,
  getHazardReportByLocationSuccess,
  getHazardReportFail,
  getHazardReportSuccess,
  saveHazardEmailFail,
  saveHazardEmailSuccess,
  submitReviewedHazardReportFail,
  submitReviewedHazardReportSuccess,
} from "./actions";
import { GET_HAZARD_REPORT, GET_HAZARD_REPROTS_BY_LOCATION, SAVE_HAZARD_EMAIL, SUBMIT_REVIEWD_HAZARD_REPORT } from "./actionTypes";
import { onGettingReportsByLocation, onGettingHazardReport, onReviewingHazaredReport, onSavingHazardEmila } from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Hazard Report";

function* onGetReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingHazardReport, data);
    yield call(responseHandler, toastTitle, response, getHazardReportSuccess, getHazardReportFail, onSuccess, onError, false);
  } catch (err) {
    onError();
    yield put(getHazardReportFail(err));
    showToast("error", toastTitle, err);
  }
}

function* onGetReportsByLocation({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingReportsByLocation, data);
    yield call(responseHandler, toastTitle, response, getHazardReportByLocationSuccess, getHazardReportByLocationFail, onSuccess, onError, false);
  } catch (err) {
    onError();
    yield put(getHazardReportByLocationFail(err));
    showToast("error", toastTitle, err);
  }
}

function* onReviewReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onReviewingHazaredReport, data);
    yield call(responseHandler, toastTitle, response, submitReviewedHazardReportSuccess, submitReviewedHazardReportFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(submitReviewedHazardReportFail(err));
    showToast("error", toastTitle, err);
  }
}

function* onSaveEmail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSavingHazardEmila, data);
    yield call(responseHandler, toastTitle, response, saveHazardEmailSuccess, saveHazardEmailFail, onSuccess, onError, false);
  } catch (err) {
    onError();
    yield put(saveHazardEmailFail(err));
    showToast("error", toastTitle, err);
  }
}

function* HazardReportSaga() {
  yield takeEvery(SAVE_HAZARD_EMAIL, onSaveEmail);
  yield takeEvery(GET_HAZARD_REPORT, onGetReport);
  yield takeEvery(SUBMIT_REVIEWD_HAZARD_REPORT, onReviewReport);
  yield takeEvery(GET_HAZARD_REPROTS_BY_LOCATION, onGetReportsByLocation);
}

export default HazardReportSaga;
